/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IMobileDevice {
        networkNode: NetworkNode;
        networkNodeType: NetworkNodeType;
        sims: ISIM[];
        totalRemainingData: number;
        transmissionRate: number;
        totalRemainingTime: string;
    }

    export class MobileDevice implements IMobileDevice {
        public networkNode: NetworkNode;
        public networkNodeType: NetworkNodeType;
        public sims: ISIM[];
        public totalRemainingData: number;
        public transmissionRate: number;
        public totalRemainingTime: string;

        public static getDefaultOrderColumn(): string {
            return "creationDate";
        }

        public static Empty(): MobileDevice {
            return new MobileDevice();
        }

        /**
         * MobileDevice's empty constructor for automatic conversion from REST data.
         */
        constructor() {
            this.networkNode = new NetworkNode();
            this.networkNodeType = new NetworkNodeType();
            this.sims = new Array();
            this.totalRemainingData = 0;
            this.transmissionRate = 5; // mbps
            this.totalRemainingTime = "-";
        }
    }
}
